import React, { useEffect, useState, useRef } from 'react';
// import './Header.css';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

//const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Dist_Month_RO_Report_data = async (params) => {  

         const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/Annavitransale`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }  

    return response.json();
};

const AnnavitranSaleReport = ({ month, year}) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Dist_Month_RO_Report_data({month,year});

                 setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
                
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, []);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
        }
    }, [loading, error, reportData]);

    
    if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
        Internal Error 
        </div>
      }
    // if (reportData.length === 0) {
    //     return <div class="mainhead" align="center">
    //     No data found 
    // </div>
    //   }  

    if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return <div className="mainhead" align="center">
        No data found
    </div>
}
      
           const totals = reportData.reduce(
                 (acc, item) => {
                   acc.aay_allot_wheat+=parseFloat(item.aay_allot_wheat) || 0;
                  acc.aay_sold_wheat += parseFloat(item.aay_sold_wheat) || 0;
                  acc.aay_allot_rice += parseFloat (item.aay_allot_rice)  || 0;
                  acc.aay_sold_rice +=  parseFloat(item.aay_sold_rice) || 0;
                  acc.aay_allot_cores += parseFloat(item.aay_allot_cores) || 0;

                    acc.aay_sold_cores +=  parseFloat (item.aay_sold_cores) ||0;
                    acc.phh_allot_wheat +=   parseFloat (item.phh_allot_wheat) ||0;
                    acc.phh_sold_wheat +=    parseFloat(item.phh_sold_wheat) ||0;

                    acc.phh_allot_rice +=    parseFloat(item.phh_allot_rice) ||0;
                    acc.phh_sold_rice +=    parseFloat(item.phh_sold_rice) ||0;
                    acc.phh_allot_cores +=  parseFloat(item.phh_allot_cores) ||0;
                    acc.phh_sold_cores += parseFloat(item.phh_sold_cores) ||0;
                    acc.phh_allot_cores += parseFloat(item.phh_allot_cores) ||0;
                    acc.phh_allot_cores +=   parseFloat(item.phh_allot_cores) ||0;
                    acc.phh_allot_cores += parseFloat(item.phh_allot_cores) ||0;
                    acc.phh_allot_cores +=   parseFloat(item.phh_allot_cores) ||0;

                    acc.state_allot_wheat +=    parseFloat(item.state_allot_wheat) ||0;
                    acc.state_sold_wheat += parseFloat(item.state_sold_wheat) ||0;
                    acc.state_allot_rice += parseFloat(item.state_allot_rice) ||0; 
                    acc.state_sold_rice +=   parseFloat(item.state_sold_rice) ||0;
                    acc.state_allot_rice += parseFloat(item.state_allot_rice) ||0; 
                    
                    acc.state_allot_cores +=    parseFloat(item.state_allot_cores) ||0;
                    acc.state_sold_cores +=   parseFloat(item.state_sold_cores) ||0;   


        
          return acc;
        },
        {
            aay_allot_wheat:0.0,
            aay_sold_wheat :0, 

            aay_allot_rice :0,
            aay_sold_rice :0, 

            aay_allot_cores :0,
            aay_sold_cores :0, 

            phh_allot_wheat :0,
            phh_sold_wheat :0,

            phh_allot_rice :0,
            phh_sold_rice :0,

            phh_allot_cores :0,
            phh_sold_cores :0,
            
                
            state_allot_wheat :0,
            state_sold_wheat :0,


            state_allot_rice :0, 
            state_sold_rice :0,

                    
             state_allot_cores :0,
             state_sold_cores :0

              
        }
      );
       
    return (
        <> 
            <table  id="myTable" align="center" width="100%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={20}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                         <td rowSpan={4}>Sl No</td>
                         <td rowSpan={4}>District</td> 
                    </tr>

                    <tr class="tableheader">
			            <td colspan={6}>AAY (in Kgs)</td>
		            	<td colspan={6}>PHH (in Kgs)</td>
			            <td colspan={6}>Non NFSA (in Kgs)</td>
		            </tr>



	                <tr class="tableheader">
			            <td colspan={2}>Wheat</td>
			            <td colspan={2}>Rice</td>
			            <td colspan={2}>Coarse Grains</td>
			            <td colspan={2}>Wheat</td>
			            <td colspan={2}>Rice</td>
			            <td colspan={2}>Coarse Grains</td>
			            <td colspan={2}>Wheat</td>
		            	<td colspan={2}>Rice</td>
			            <td colspan={2}>Coarse Grains</td>
		            </tr>


                	<tr class="tableheader">
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
                        <td>Alloted</td>
                        <td>Sale</td>
	            	</tr>

                   
                </thead>
                <tbody>
                    { 
                        reportData.map((item, index) => (
                            <tr key={item.dfso_nm}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ textAlign: 'left' }}> {item.dfso_nm}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_allot_wheat}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_sold_wheat}</td>
                                    <td style={{ textAlign: 'right' }}   >{item.aay_allot_rice}</td>
                                    <td style={{ textAlign: 'right' }}  >{item.aay_sold_rice}  </td>
                                    <td style={{ textAlign: 'right' }}  >{item.aay_allot_cores}</td>
                                    <td style={{ textAlign: 'right' }}  >{item.aay_sold_cores}</td>
                                    <td style={{ textAlign: 'right' }}  >{item.phh_allot_wheat}</td>
                                    <td style={{ textAlign: 'right' }} >{item.phh_sold_wheat}</td>

                                    <td style={{ textAlign: 'right' }}>{item.phh_allot_rice}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_sold_rice}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_allot_cores}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_sold_cores}</td>
                                    <td style={{ textAlign: 'right' }}>{item.state_allot_wheat}</td>
                                    <td style={{ textAlign: 'right' }}>{item.state_sold_wheat}</td>
                                    <td style={{ textAlign: 'right' }}>{item.state_allot_rice}</td>
                                    <td style={{ textAlign: 'right' }}>{item.state_sold_rice}</td>
                                    <td style={{ textAlign: 'right' }}>{item.state_allot_cores}</td>
                                    <td style={{ textAlign: 'right' }} >{item.state_sold_cores}</td>
                                
                            </tr>
                        ))
                     }
                    <tr className="tableheader">
                      <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_allot_wheat||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_sold_wheat||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_allot_rice||0).toFixed(2)}</td>    
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_sold_rice||0).toFixed(2)}</td>     
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_allot_cores||0).toFixed(2)}</td>                                           
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_sold_cores||0).toFixed(2)}</td>                                          
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_allot_wheat||0).toFixed(2)}</td>    
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_sold_wheat||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_allot_rice||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_sold_rice||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_allot_core||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_sold_core||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.state_allot_wheat||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.state_sold_wheat||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.state_allot_rice||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.state_sold_rice||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.state_allot_core||0).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.state_sold_core||0).toFixed(2)}</td>
                             
                   </tr>  
                </tbody>
           </table>
            <br /><br /> <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default AnnavitranSaleReport;
